export default __webpack_public_path__ + "static/media/fortmatic.dc6b075a.webp";